/**
 * @generated SignedSource<<9d4e9b22b6f372c74d3b77fca372c600>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TodoStatus = "DONE" | "PENDING";
import { FragmentRefs } from "relay-runtime";
export type TodoListItemMainContentDetails_todo$data = {
  readonly images: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"Image_image">;
  }>;
  readonly linkedProducts: ReadonlyArray<{
    readonly imageUrl: string | null;
  }>;
  readonly status: TodoStatus;
  readonly " $fragmentSpreads": FragmentRefs<"TodoListItemCompletedInfo_todo">;
  readonly " $fragmentType": "TodoListItemMainContentDetails_todo";
};
export type TodoListItemMainContentDetails_todo$key = {
  readonly " $data"?: TodoListItemMainContentDetails_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoListItemMainContentDetails_todo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoListItemMainContentDetails_todo",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoListItemCompletedInfo_todo"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "images",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Image_image"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreProduct",
      "kind": "LinkedField",
      "name": "linkedProducts",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Todo",
  "abstractKey": null
};

(node as any).hash = "a121f393f6e85910987540167a1fa266";

export default node;
